import React from "react";
import { HeaderDescription, Tabs } from "@pickit/pickit-components";
import { PolygonsProps } from "./types";
import GeneralContainer from "./general/GeneralContainer";
import Pricing from "./pricing/PricingContainer";
import FilterPolygons from "./filter/FilterPolygonsContainer";
import { useTranslation } from "react-i18next";
import "./Polygons.scss";
import "./i18n";
import { AlignTypes } from "@pickit/pickit-components/dist/Tabs/types";

export const Polygons = ({
  tabs,
  actualPage,
  testId,
  changePage,
}: PolygonsProps) => {
  const { t } = useTranslation();
  return (
    <>
      <HeaderDescription
        headline={t("polygon:polygons")}
        overline="Configuraciones"
        testId={`${testId}-title`}
      />
      <div className="header-container">
        <Tabs
          tabs={tabs.map(({ title, icon, disabled, testId }) => ({ title, icon, disabled, testId }))}
          initialIndex={Math.max(tabs.findIndex((t) => t.id === actualPage), 0)}
          onChange={(action, index) => {
            action();
            changePage(tabs[index ?? 0].id);
          }}
          align={"left" as AlignTypes}
          size="large"
          width="25%"
        >
          <>
            <>
              <div className="polygons-container">
                <FilterPolygons testId={`${testId}-filters`} />
              </div>
              <div className="polygons-container">
                <GeneralContainer testId={`${testId}-general`} />
              </div>
            </>
            <>
              <div className="polygons-container">
                <FilterPolygons testId={`${testId}-filters`} />
              </div>
              <div className="polygons-container">
                <Pricing testId={`${testId}-pricing`} />
              </div>
            </>
          </>
        </Tabs>
      </div>
    </>
  );
};
